import styled, { css } from 'styled-components';
import { rootStyle } from "../../styles";
export var List = styled.ul.attrs(function (props) {
  return {
    role: props.role || 'list'
  };
}).withConfig({
  displayName: "List",
  componentId: "sc-64p3hb-0"
})(["", ";padding-inline-start:0;padding-inline-end:0;margin-block-start:0;margin-block-end:0;overflow-wrap:break-word;", ";"], rootStyle(), function (props) {
  return props.listStyleReset !== false && css(["list-style-type:none;"]);
});
/**
* **List** ![Status: Production](https://img.shields.io/badge/PRODUCTION-%2357B560|height=14)
*
* [GitHub](https://ghe.spotify.net/encore/web/tree/master/src/core/components/List) | [Storybook](https://encore-web.spotify.net/?path=/docs/components-list--default) | [Encore](https://encore.spotify.net/web/components/list) | 
*
* List lets you conveniently incorporate unstyled semantic list structures.
*
* @example
* () => (
*  <List>
*    <ListItem>List item</ListItem>
*    <ListItem>List item</ListItem>
*    <ListItem>List item</ListItem>
*    <ListItem>List item</ListItem>
*  </List>
*);
*
*/

export default List;